

import WalletConnect from '../WalletConnect/WalletConnect';

const LiquidityBanner = () => {
  return (
    <>
      <section className="brandbanner_bg liquiditybanner">
        <img
          src="\assets\homepage\banner\banner-shadow.png"
          alt="img"
          className="img-fluid banner-shadow"
        />
        <video
          className="main-banner-video"
          muted="muted"
          playsInline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo"
        >
          <source src="\assets\bannervideo.mp4" type="video/mp4" />
        </video>
        <div className="custom-container brandbanner">
          <div className="twice-text">
            <h3 className="brandbanner__heading">Leverage Liquidity Provision</h3>
            <p className="brandbanner__para">
            Deposit funds into the <b>Rain Shared Liquidity Pool</b> and power a new generation of high-velocity markets. Earn up to 1.5% in rewards by backing the core infrastructure that builders and players rely on.            </p>
          </div>
          <WalletConnect />
        </div>
      </section>
    </>
  );
};

export default LiquidityBanner;